import React from 'react';

export const TaskDetailsContext = React.createContext<
  { value: boolean; setShowOnlyQualified: React.Dispatch<boolean> } | undefined
>(undefined);
